import axiosInstance from "../utils/axiosConfig";
import { getErrorMessage } from "../utils/errorHandler";

export const fetchEventosAtuais = async (codigoMotorista, dataInicial, dataFinal) => {
  try {
    const baseUrl = "https://workflow.grupocenze.com.br:38137/rest2/";

    console.log("=== DEBUG API ===");
    console.log("URL:", `${baseUrl}INT_PAPELETA_WSMARCACOES`);
    console.log("Parâmetros:", { id_motorista: codigoMotorista, data_inicial: dataInicial, data_final: dataFinal });

    const response = await axiosInstance.get(`${baseUrl}INT_PAPELETA_WSMARCACOES`, {
      params: {
        id_motorista: codigoMotorista,
        data_inicial: dataInicial,
        data_final: dataFinal
      },
      timeout: 30000,
    });

    if (response.data && Array.isArray(response.data)) {
      return response.data;
    } else {
      throw new Error("Resposta da API não contém dados válidos");
    }
  } catch (error) {
    console.error("Erro ao buscar eventos atuais:", error);
    
    // Usar o utilitário para tratar todos os tipos de erro de forma consistente
    throw new Error(getErrorMessage(error, "buscar eventos atuais"));
  }
};
